import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {PrlInitializer} from "./prl-initializer.interface";
import {PrlValidationManagerService} from "./prl-validation-manager.service";
import {PrlTimezoneService} from "./prl-timezone.service";
import {PrlTitleAndBreadcrumbsService} from "./prl-title-and-breadcrumbs.service";
import {PrlInformationService} from "./prl-information.service";
import {PrlAuthPingService} from "./prl-auth-ping.service";
import {
    PrlPortalNotificationService
} from '../../view/prl-authentication/services/portal-notification-page/prl-portal-notification.service';

@Injectable({
    providedIn: 'root'
})
export class PrlInitializeService {

    private _services: Array<PrlInitializer> = [];
    private _userName$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(
        private valid: PrlValidationManagerService,
        private time: PrlTimezoneService,
        private ping: PrlAuthPingService,
        private breadcrumbs: PrlTitleAndBreadcrumbsService,
        private informationService: PrlInformationService,
        private portalNotification: PrlPortalNotificationService
    ) {
        this.register(valid);
        this.register(time);
        this.register(ping);
        this.register(breadcrumbs);
        this.register(informationService);
        this.register(portalNotification);
    }

    public register(service: PrlInitializer): void {
        this._services.push(service);
    }

    public getService(): ReadonlyArray<PrlInitializer> {
        return [...this._services];
    }

    public getUserName(): Observable<string> {
        return this._userName$;
    }

    public setUserName(userName: string | null): void {
        this._userName$.next(userName);
    }

}
